import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-minimize",
  "use": "icon_player-minimize-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-minimize\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M8 3v5H3m18 0h-5V3M3 16h5v5m8 0v-5h5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol